/**
 * @fileoverview HeaderMenu component.core
 *
 */
'use strict';
// React Import
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// Library Import
import _ from 'lodash';
import mobiscroll from '../../lib/mobiscroll/forms.react';
import '../../lib/mobiscroll/navigation.react';
// Util Import
import * as ConstUtil from '../../util/ConstUtil';
import AppConfig from '../../AppConfig';

/**
 * ポータルヘッダーメニューコンポーネント
 *
 * @class HeaderMenu
 * @extends {Component}
 */
class HeaderMenu extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, 'clickMenu');
  }

  /**
   * メニュークリック
   *
   * @param {Object} event event
   * @memberof HeaderMenu
   */
  clickMenu(event) {
    let dataset = event.target.dataset;
    // ボタン
    let url = event.target.id;
    // ハンバーガーメニューの場合
    if (!_.isEmpty(dataset.id)) {
      url = event.target.dataset.id;
    }
    // リンクの場合
    if (url.indexOf(AppConfig.httpScheme) !== -1) {
      window.location.href = url;
      return;
    }
    this.props.history.push(url);
    window.location.reload();
  }

  /**
   * 配送業者メニュー要素の描画
   *
   * @returns {Object} 配送業者メニュー要素
   * @memberof HeaderMenu
   */
  renderContractor() {
    return (
      <Fragment>
        <mobiscroll.Button
          id={ConstUtil.Common.COMPONENT.PORTAL_TOP.URL}
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID101}
        </mobiscroll.Button>
        <mobiscroll.Button
          id={ConstUtil.Common.COMPONENT.DRIVER_LIST.URL}
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID103}
        </mobiscroll.Button>
        {/* <mobiscroll.Button
          id={ConstUtil.Common.COMPONENT.CAR_LIST.URL}
          onClick={this.clickMenu}
        >
          {ConstUtil.Message.COMMON.ID102}
        </mobiscroll.Button> */}
      </Fragment>
    );
  }

  /**
   * ドライバーメニュー要素の描画
   *
   * @returns {Object} ドライバーメニュー要素
   * @memberof HeaderMenu
   */
  renderDriver() {
    return (
      <mobiscroll.Button
        id={ConstUtil.Common.COMPONENT.PORTAL_TOP.URL}
        onClick={this.clickMenu}
      >
        {ConstUtil.Message.COMMON.ID101}
      </mobiscroll.Button>
    );
  }

  /**
   * メニュー要素の描画
   *
   * @returns {Object} メニュー要素
   * @memberof HeaderMenu
   */
  renderMenu() {
    // 権限を取得
    let authorityId = localStorage.getItem(
      ConstUtil.Common.STORAGE_KEY.AUTHORITY_ID
    );
    switch (authorityId) {
      // 配送業者
      case ConstUtil.Common.AUTHORITY_LIST.CONTRACTOR:
        return this.renderContractor();
      // ドライバー
      case ConstUtil.Common.AUTHORITY_LIST.DRIVER:
        return this.renderDriver();
      // システム管理者
      case ConstUtil.Common.AUTHORITY_LIST.SYSTEM_MANAGER:
        return;
      default:
        break;
    }
  }

  /**
   * 描画
   *
   * @returns {Object} 画面を構成する要素
   * @memberof HeaderMenu
   */
  render() {
    return <div className="header-menu-area">{this.renderMenu()}</div>;
  }
}

HeaderMenu.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func })
};
export default withRouter(HeaderMenu);



// WEBPACK FOOTER //
// ./src/js/component/core/HeaderMenu.jsx